module.exports = __webpack_public_path__ + "media/images/th-group-aacf5debfac28681ee9ffb7878ae5535.svg";